export enum FreshServiceStatusEnum {
    Open = 2,
    Pending,
    Resolved,
    Closed,
}
